import { alternates, timezones } from '../assets/timezones';

export function detectUserCountry(): string | null {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const place = tz.split('/')[1];
  const fromTz = timezones[place];

  const lang = navigator.language || '';
  const fromLang = lang.split('-')[1];

  if (fromLang && alternates[place]?.includes(fromLang)) return fromLang;

  return fromTz || fromLang || null;
}
